import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Hero from './components/Hero';
import IntroSection from './components/IntroSection';
import InsightsSection from './components/InsightsSection';
import ServicesSection from './components/ServicesSection';
import ContactBanner from './components/ContactBanner';
import Footer from './components/Footer';
import StatsBanner from './components/StatsBanner';
import ContactUsBanner from './components/ContactUsBanner';
import NewsDetailPage from './components/NewsDetailPage';


const Home = () => (
  <>
    <Header />
    <Hero />
    <Box sx={{ overflowX: 'hidden' }}>
      <IntroSection />
    </Box>
    <ServicesSection />
    <ContactUsBanner />
    <StatsBanner />
    <InsightsSection />
    <ContactBanner />
    <Footer />
  </>
);

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/news/:slug" element={<NewsDetailPage />} />


      </Routes>
    </Router>
  );
};

export default App;
